export default __webpack_public_path__ + "static/media/img6.36425bf0.jpg";